module.exports = __webpack_public_path__ + "static/media/hired-color.86eac324.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/get-started/hired-color.png
// module id = 1534
// module chunks = 3